import {
  Alert,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

export const FieldWarning = ({ warningText }) => {
  return (
    <Alert
      severity="error"
      variant="outlined"
      sx={{
        mt: 2,
        mb: 2,
        p: "4px 8px",
        borderRadius: "4px",
        alignItems: "center",
        border: "2px solid #80278c",
        backgroundColor: "transparent",
       
        // borderImage: "linear-gradient(90deg, #80278c, #80278c) 1",
        "& .MuiAlert-message": {
          fontSize: "0.8rem",
          lineHeight: "1rem",
          padding: 0,
          margin: 0,
        },
        "& .MuiAlert-icon": {
          fontSize: "1rem",
          mr: 0.5,
          color: (theme) => theme.palette.error.main,
        },
      }}
    >
      {warningText ?? "-"}
    </Alert>
  );
};

export const SavingLoader = () => {
  return (
    <Stack direction="row" gap={1} alignItems="center" >
      Saving...
      <CircularProgress size={20} color="inherit" />
    </Stack>
  );
};

export const BackButton = () => {
  return (
    <Button
      onClick={() => window.history.back()}
      variant="outlined"
      size="small"
      startIcon={<ArrowBackIosNewRoundedIcon sx={{ fontSize: 11, ml: 0.5 }} />}
      sx={{
        borderRadius: "30px",
        px: 2.5,
        py: 0.6,
        minWidth: 90,
        color: "#16A2DD",
        border: "1px solid #16A2DD",
        // color: "#fff",
        textTransform: "none",
        fontWeight: 500,
        gap: 0.5,
        // "&:hover": {
        //   backgroundColor: "#1291c7",
        //   color: "#fff",
        // },
      }}
    >
      Back
    </Button>
  );
};
